/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Hanly API v2
 * OpenAPI spec version: 0.0.1
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type { ErrorType } from '../../custom-client';

import { customInstance } from '../../custom-client';
import type {
  DetailError,
  PaginatedSalesOrder,
  SalesOrderDetail,
  SalesOrderListParams,
  ShipmentCreateRequest,
  ShipmentDetail,
  StandardizedError,
} from '../hanlyAPIV2.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSalesOrderListUrl = (params?: SalesOrderListParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v2/sales-orders/orders?${stringifiedParams}`
    : '/api/v2/sales-orders/orders';
};

/**
 * @summary 注文データ一覧を返す
 */
export const salesOrderList = async (
  params?: SalesOrderListParams,
  options?: Parameters<typeof customInstance>[1],
): Promise<PaginatedSalesOrder> => {
  return customInstance<PaginatedSalesOrder>(getSalesOrderListUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getSalesOrderListQueryKey = (params?: SalesOrderListParams) => {
  return ['/api/v2/sales-orders/orders', ...(params ? [params] : [])] as const;
};

export const getSalesOrderListQueryOptions = <
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSalesOrderListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderList>>> = ({ signal }) =>
    salesOrderList(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof salesOrderList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SalesOrderListQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderList>>>;
export type SalesOrderListQueryError = ErrorType<StandardizedError | DetailError>;

export function useSalesOrderList<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | SalesOrderListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderList>>,
          TError,
          Awaited<ReturnType<typeof salesOrderList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSalesOrderList<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderList>>,
          TError,
          Awaited<ReturnType<typeof salesOrderList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSalesOrderList<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 注文データ一覧を返す
 */

export function useSalesOrderList<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSalesOrderListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSalesOrderListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSalesOrderListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderList>>> = ({ signal }) =>
    salesOrderList(params, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type SalesOrderListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderList>>>;
export type SalesOrderListSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useSalesOrderListSuspense<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | SalesOrderListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSalesOrderListSuspense<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSalesOrderListSuspense<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 注文データ一覧を返す
 */

export function useSalesOrderListSuspense<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSalesOrderListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSalesOrderDetailUrl = (id: number) => {
  return `/api/v2/sales-orders/orders/${id}`;
};

/**
 * @summary 注文データの詳細を取得する
 */
export const salesOrderDetail = async (
  id: number,
  options?: Parameters<typeof customInstance>[1],
): Promise<SalesOrderDetail> => {
  return customInstance<SalesOrderDetail>(getSalesOrderDetailUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getSalesOrderDetailQueryKey = (id: number) => {
  return [`/api/v2/sales-orders/orders/${id}`] as const;
};

export const getSalesOrderDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSalesOrderDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderDetail>>> = ({ signal }) =>
    salesOrderDetail(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof salesOrderDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SalesOrderDetailQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderDetail>>>;
export type SalesOrderDetailQueryError = ErrorType<StandardizedError | DetailError>;

export function useSalesOrderDetail<
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderDetail>>,
          TError,
          Awaited<ReturnType<typeof salesOrderDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSalesOrderDetail<
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderDetail>>,
          TError,
          Awaited<ReturnType<typeof salesOrderDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSalesOrderDetail<
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 注文データの詳細を取得する
 */

export function useSalesOrderDetail<
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSalesOrderDetailQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSalesOrderDetailSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSalesOrderDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderDetail>>> = ({ signal }) =>
    salesOrderDetail(id, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type SalesOrderDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderDetail>>>;
export type SalesOrderDetailSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useSalesOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSalesOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSalesOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 注文データの詳細を取得する
 */

export function useSalesOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof salesOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSalesOrderDetailSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSalesOrderShipmentCreateUrl = () => {
  return '/api/v2/sales-orders/shipments';
};

/**
 * 指定した受注明細を出荷する。出荷済みの明細・キャンセル済みの受注の明細は出荷できない。期限切れのロットが割り当てられた明細は allow_expired_lots を指定しなければ 400 にする。
 * @summary 出荷を作成する
 */
export const salesOrderShipmentCreate = async (
  shipmentCreateRequest: ShipmentCreateRequest,
  options?: Parameters<typeof customInstance>[1],
): Promise<ShipmentDetail> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customInstance<ShipmentDetail>(getSalesOrderShipmentCreateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shipmentCreateRequest),
  });
};

export const getSalesOrderShipmentCreateMutationKey = () => ['salesOrderShipmentCreate'] as const;

export const getSalesOrderShipmentCreateMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof salesOrderShipmentCreate>>,
    TError,
    SalesOrderShipmentCreateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof salesOrderShipmentCreate>>,
  TError,
  SalesOrderShipmentCreateMutationVariables,
  TContext
> => {
  const mutationKey = getSalesOrderShipmentCreateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof salesOrderShipmentCreate>>,
    SalesOrderShipmentCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return salesOrderShipmentCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SalesOrderShipmentCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof salesOrderShipmentCreate>>
>;
export type SalesOrderShipmentCreateMutationBody = ShipmentCreateRequest;
export type SalesOrderShipmentCreateMutationError = ErrorType<StandardizedError | DetailError>;
export type SalesOrderShipmentCreateMutationVariables = { data: ShipmentCreateRequest };

/**
 * @summary 出荷を作成する
 */
export const useSalesOrderShipmentCreate = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof salesOrderShipmentCreate>>,
      TError,
      SalesOrderShipmentCreateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof salesOrderShipmentCreate>>,
  TError,
  SalesOrderShipmentCreateMutationVariables,
  TContext
> => {
  return useMutation(getSalesOrderShipmentCreateMutationOptions(options), queryClient);
};
